module.exports = __webpack_public_path__ + "static/media/hero-screenshot-2.31c082be.png";